import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
// const originalPush = VueRouter.prototype.push;
// //修改原型对象中的push方法
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch((err) => err);
// };
const routes = [
  {
    path: "/",
    // name: "index",
    component: () => import("../views/index.vue"),
    redirect: '/home',
    children: [
      {
        path: "",
        name: "home",
        component: () => import("../views/homeIndex.vue"),
      },
      {
        path: "userInfo",
        name: "userInfo",
        component: () => import("../views/userInfo.vue"),
      },
      {
        path: "register",
        name: "register",
        component: () => import("../views/register.vue"),
      },
      {
        path: "citySelect",
        name: "citySelect",
        component: () => import("../views/citySelect.vue"),
      },
      {
        path: "companyInfo",
        name: "companyInfo",
        component: () => import("../views/companyInfo.vue"),
      },
      {
        path: "noticeDetails/:id",
        name: "noticeDetails",
        component: () => import("../views/noticeDetails.vue"),
      },
      {
        path: "jobListView",
        name: "jobListView",
        component: () => import("../views/jobListView.vue"),
      },
      {
        path: "workerListView",
        name: "workerListView",
        component: () => import("../views/workerListView.vue"),
      },
      {
        path: "jobDetailView/:id",
        name: "jobDetailView",
        component: () => import("../views/jobDetailView.vue"),
      },
      {
        path: "workerDetailView/:id",
        name: "workerDetailView",
        component: () => import("../views/workerDetailView.vue"),
      },
      {
        path: "userCenter",
        name: "userCenter",
        component: () => import("../views/userCenter.vue"),
      },
      {
        path: "aboutUs",
        name: "aboutUs",
        component: () => import("../views/aboutUs.vue"),
        meta: {
          title: "关于我们",
        },
      },
      {
        path: "joinUs",
        name: "joinUs",
        component: () => import("../views/joinUs.vue"),
        meta: {
          title: "加入我们",
        },
      },
      {
        path: "agreement",
        name: "agreement",
        component: () => import("../views/agreement.vue"),
        meta: {
          title: "协议与规则",
        },
      },
      {
        path: "agency",
        name: "agency",
        component: () => import("../views/agency.vue"),
        meta: {
          title: "招商渠道",
        },
      },
      {
        path: "app",
        name: "app",
        component: () => import("../views/app.vue"),
        meta: {
          title: "APP",
        },
      },
    ],
  },

  {
    path: "/app/guider",
    name: "guider",
    component: () => import("../views/guider.vue"),
    meta: {
      title: "千万职联",
    },
  },
  {
    path: "/weixin/share",
    name: "share",
    component: () => import("../views/share.vue"),
    meta: {
      title: "千万职联小程序",
    },
  },
  {
    path: "/alipay/bind",
    name: "bind",
    component: () => import("../views/alipayFace.vue"),
    meta: {
      title: "人脸认证",
    },
  },
  {
    path: "/invite/share",
    name: "invite",
    component: () => import("../views/inviteShare.vue"),
    meta: {
      title: "千万职联活动",
    },
  },
  {
    path: "/common/share",
    name: "commShare",
    component: () => import("../views/commShare.vue"),
    meta: {
      title: "千万职联分享",
    },
  },
  {
    path: "/job/employeeFile",
    name: "employeeFile",
    component: () => import("../views/employeeFile.vue"),
    meta: {
      title: "邀请填写入职信息",
    },
  },
  {
    path: "/app/courseShare",
    name: "courseShare",
    component: () => import("../views/app/courseShare.vue"),
    meta: {
      title: "课程分享",
    },
  },
  {
    path: "/app/talentShare",
    name: "talentShare",
    component: () => import("../views/app/talentShare.vue"),
    meta: {
      title: "人才简历分享",
    },
  },
  {
    path: "/scanCoupon",
    name: "scanCoupon",
    component: () => import("../views/app/scanCoupon.vue"),
    meta: {
      title: "扫码领券",
    },
  },
  {
    path: "/app/pptViewer",
    name: "pptViewer",
    component: () => import("../views/app/pptViewer.vue"),
    meta: {
      title: "ppt预览",
    },
  },
  {
    path: "/app/JobSharingH5",
    name: "JobSharingH5",
    component: () => import("../views/app/JobSharingH5/index.vue"),
    meta: {
      title: "职位分享H5",
    },
  },
  {
    path: "/app/open",
    name: "openApp",
    component: () => import("../views/app/openApp.vue"),
    meta: {
      title: "千万职联",
    },
  },
  {
    path: "/wechat/enter",
    name: "enter",
    component: () => import("../views/cpyEnter.vue"),
    meta: {
      title: "千万职联活动",
    },
  },
  {
    path: "/openTheMiniProgram",
    name: "openTheMiniProgram",
    component: () => import("../views/openTheMiniProgram.vue"),
    meta: {
      title: "小程序跳转中",
    },
  },
    {
    path: "/openTheMiniProgramTest",
    name: "openTheMiniProgramTest",
    component: () => import("../views/openTheMiniProgram_test.vue"),
    meta: {
      title: "小程序跳转中-测试",
    },
  },
  {
    path: "/myCompany",
    name: "myCompany",
    component: () => import("../views/myCompany.vue"),
    meta: {
      title: "千万职联",
    },
  },
  {
    path: "*",
    redirect: "/",
  },
];

console.log(process.env);
const router = new VueRouter({
   mode: process.env.NODE_ENV === "development" ? "hash" : "hash",      // 只用于活动 #
 // mode: process.env.NODE_ENV === "development" ? "history" : "history",  // 只用于官网 不带#
  //base: "qwzl",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
export default router;
